import { Anchor } from "lucide-react";

const PHRASES = [
  "OCEAN MINDED",
  "COMMUNITY DRIVEN",
  "A HIGHER STANDARD",
  "CAN YOU MAKE THE CUT?",
  "PACIFIC ADVENTURES",
];

export const Marquee = () => (
  <div className="border-y border-[#D4AF37]/15 bg-[#0A0E14] py-5 overflow-hidden" data-testid="manifesto-marquee">
    <div className="marquee-track flex w-max whitespace-nowrap">
      {[...PHRASES, ...PHRASES, ...PHRASES, ...PHRASES].map((text, i) => (
        <span key={i} className="flex items-center font-display text-xs md:text-sm tracking-[0.45em] text-[#D4AF37]/70">
          <span className="px-8">{text}</span>
          <Anchor size={13} className="text-[#D4AF37]/35 shrink-0" />
        </span>
      ))}
    </div>
  </div>
);
